import { useState, useEffect } from "react";
import { useLazyQuery } from "@apollo/client";
import styled from "styled-components";

import Navbar from "../components/Nabvar";
import Footer from "../components/Footer";
import { SearchBar } from "../components/ui";
import {
  AgregarMovimientos,
  DatosContacto,
  General,
} from "../components/pageComponents/CapturaSiniestro";

import { GET_CONTRACTS_SEARCH } from "../services/contract/contracts";
import { useContract } from "../redux/contractReducer";
import { useSiniester } from "../redux/siniesterReducer";

import "react-responsive-modal/styles.css";

const Container = styled.div`
  width: 100%;
  position: relative;
  min-height: calc(100vh - 62px);
  padding-top: 70px;
`;

//---- HEADER ----//
const HeaderWrapper = styled.div`
  background-color: var(--primary-royal-blue);
  display: grid;
  place-content: center;
  @media only screen and (max-width: 768px) {
    width: 100vw;
  } ;
`;
const Header = styled.div`
  width: 1200px;
  background-color: var(--primary-royal-blue);
  padding: 56px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media only screen and (max-width: 1280px) {
    width: 90vw;
  }
  @media only screen and (max-width: 768px) {
    width: 94vw;
    display: block;
    gap: 20px;
  } ;
`;

const Title = styled.h1`
  color: #fff;
  line-height: 26px;
  @media only screen and (max-width: 768px) {
    width: 100%;
    display: block;
    gap: 20px;
    margin-bottom: 20px;
  } ;
`;

//---- MODULE ----//
const ModuleWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  &:after {
    background-color: var(--primary-royal-blue);
    content: "";
    top: 0;
    height: 200px;
    width: 100%;
    position: absolute;
    z-index: -1;
  }
`;

export default function CapturaSiniestro() {
  const [contracts, setContracts] = useState([]);
  const [dataSelected, setDataSelected] = useState(null);
  const [contractSelected, setContractSelected] = useState(null);
  const [generalOpen, setGeneralOpen] = useState(false);
  const { contractState, setContract, resetContract } = useContract();
  const { resetSiniester } = useSiniester();
  const [onListSearch, setOnListSearch] = useState("");
  const [movementOpen, setMovementOpen] = useState(false);
  const executeSubmit = (func) => {
    if (func)
      func();
  };
  // Queries
  const [getContractsSearch] = useLazyQuery(GET_CONTRACTS_SEARCH, {
    fetchPolicy: "network-only",
    onCompleted({ getContractsSearch }) {
      if (getContractsSearch.statusCode === 200) {
        const resultFormatJson = JSON.parse(getContractsSearch.response);
        setContracts(resultFormatJson);
      }
    },
  });

  const handleOnChange = (valueInput) => {
    getContractsSearch({
      variables: {
        nameContract: valueInput,
      },
    });
  };

  useEffect(() => {
    if (contractState?.siniester === true) {
      setDataSelected(contractState);
      setContractSelected(contractState);
      setGeneralOpen(true);
      setContract({...contractState, siniester: false});
    } else {
      setDataSelected(null);
      setContractSelected(null);
      setGeneralOpen(false);
      resetContract();
      resetSiniester();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (dataSelected) {
      setContractSelected(null);
      setGeneralOpen(false);
      setMovementOpen(false);
      resetSiniester();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataSelected]);



  return (
    <>
      <Container>
        <Navbar />
        <HeaderWrapper>
          <Header>
            <Title>Captura de Siniestro</Title>
            <SearchBar
              nameKey={"nombre"}
              placeholder={"Buscar contrato"}
              setDataSelected={setDataSelected}
              onChange={handleOnChange}
              value={onListSearch}
              setValue={setOnListSearch}
              dataSearched={contracts}
              setDataSearched={setContracts}
            />
          </Header>
        </HeaderWrapper>
        <ModuleWrapper>
          <DatosContacto
            setContractSelected={setContractSelected}
            dataContact={dataSelected}
          />
          <General
            contract={contractSelected}
            generalOpen={generalOpen}
            setGeneralOpen={setGeneralOpen}
            executeSubmit={executeSubmit}
          />
          <AgregarMovimientos
            contract={contractSelected}
            setMovementOpen={setMovementOpen}
            movementOpen={movementOpen}
            shouldSubmit={true}
          />
          {/* {pagoMovimientos.map((item) => (
            <PagoMovimientos key={item.id} data={item} />
          ))} */}
        </ModuleWrapper>
      </Container>
      <Footer />
    </>
  );
}
